<template>
  <el-dialog
    title="编辑提供商"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <!-- 表单 -->
    <el-form
      ref="editForm"
      :model="formData"
      :rules="formRules"
      label-width="140px"
      size="small"
     >
      <!-- 提供商 -->
      <el-form-item label="提供商：" prop="provider">
        <el-input
          v-model="formData.provider"
          placeholder="请输入提供商名称"
          clearable
        />
      </el-form-item>
      <!-- 资源所在地 -->
      <el-form-item label="资源所在地：" prop="location">
        <el-input
          v-model="formData.location"
          placeholder="请输入资源所在地"
          clearable
        />
      </el-form-item>
      <!-- GPU型号 -->
      <el-form-item label="GPU型号：" prop="gpu_model">
        <el-input
          v-model="formData.gpu_model"
          placeholder="请输入GPU型号"
          clearable
        />
      </el-form-item>
      <!-- 规模 -->
      <el-form-item label="规模：" prop="scale">
        <el-input
          type="textarea" 
          :rows="3"
          v-model="formData.scale"
          placeholder="请输入规模"
          clearable
        />
      </el-form-item>
      <!-- 联系电话 -->
      <el-form-item label="联系电话：" prop="provider_tel">
        <el-input
          v-model="formData.provider_tel"
          placeholder="请输入联系电话"
          clearable
        />
      </el-form-item>
      <!-- 联系人 -->
      <el-form-item label="联系人：" prop="contacts">
        <el-input
          v-model="formData.contacts"
          placeholder="请输入联系人"
          clearable
        />
      </el-form-item>
      <!-- 租赁规模 -->
      <el-form-item label="租赁规模：" prop="lease_scale">
        <el-select v-model="formData.lease_scale" placeholder="请选择" style="width: 100%;">
          <el-option label="任意" :value="0" />
          <el-option label="整租" :value="1" />
          <el-option label="散租" :value="2" />
        </el-select>
      </el-form-item>

      <!-- 租赁类型 -->
      <el-form-item label="租赁形式：" prop="lease_type">
        <el-select v-model="formData.lease_type" placeholder="请选择" style="width: 100%;">
          <el-option label="任意" :value="0" />
          <el-option label="开口" :value="1" />
          <el-option label="闭口" :value="2" />
        </el-select>
      </el-form-item>

      <!-- 状态 -->
      <el-form-item label="状态：" prop="status">
        <el-select v-model="formData.status" placeholder="请选择" style="width: 100%;">
          <el-option label="有效" :value="0" />
          <el-option label="关闭" :value="1" />
          <el-option label="待定" :value="2" />
        </el-select>
      </el-form-item>

      <!-- 开始时间 -->
      <el-form-item label="开始时间：" prop="start_time">
        <el-date-picker
          v-model="formData.start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
          style="width: 100%;"
        />
      </el-form-item>

      <!-- 结束时间 -->
      <el-form-item label="结束时间：" prop="end_time">
        <el-date-picker
          v-model="formData.end_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
          style="width: 100%;"
        />
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注：" prop="remark">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>

    <!-- 按钮 -->
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'EditProvider',

  data() {
    return {
      dialogVisible: false,
      providerId: '', // 存储要编辑的记录 ID

      // 表单数据
      formData: {
        provider: '',
        location: '',
        contacts: '',
        provider_tel: '',
        gpu_model: '',
        scale: '',
        lease_scale: 0,
        lease_type: 0,
        status: 0,
        start_time: '',
        end_time: '',
        remark: ''
      },

      // 表单校验规则
      formRules: {
        provider: [{ required: true, message: '请输入提供商', trigger: 'blur' }],
        location: [{ required: true, message: '请输入地理位置', trigger: 'blur' }],
        scale: [{ required: true, message: '请输入规模', trigger: 'blur' }],
        gpu_model: [{ required: true, message: '请输入GPU型号', trigger: 'blur' }],
        provider_tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        start_time: [
          {
            validator: (rule, value, callback) => {
              // 非必填，留空也通过
              callback();
            },
            trigger: 'change'
          }
        ],

        // 结束时间：非必填，但若填写则必须 > 开始时间
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.formData.start_time;
              const endTime = value;

              // 如果两个时间都没填 → 通过
              if (!startTime && !endTime) {
                return callback();
              }

              // 如果只填了结束时间 → 通过（非必填）
              if (!startTime && endTime) {
                return callback();
              }

              // 如果只填了开始时间 → 通过
              if (startTime && !endTime) {
                return callback();
              }

              // 两个都填了，才做比较
              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('可用期结束时间必须大于开始时间'));
              } else {
                callback(); // 校验通过
              }
            },
            trigger: 'change'
          }
        ],
      }
    };
  },

  methods: {
    /**
     * 打开编辑弹窗
     * @param {Object} row - 当前行数据，必须包含 id
     */
    openDialog(row) {
      if (!row || !row.id) {
        this.$message.error('无效的数据，缺少 ID');
        return;
      }

      // 保存 ID
      this.providerId = row.id;

      // 填充表单（深拷贝，避免引用）
      this.formData = { ...row };

      // 显示弹窗
      this.dialogVisible = true;

      // 清除校验
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
      });
    },

    /**
     * 重置表单（关闭时调用）
     */
    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.providerId = '';
    },

    /**
     * 提交编辑
     */
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;

        // 使用 this.$axios.put
        this.$axios.put(`/api-30216/api/regions/${this.providerId}`, this.formData)
          .then(res => {
              const responseData = res.data || res;
              if (responseData.code === 200) {
                this.$message.success(responseData.message || '更新成功');
                this.dialogVisible = false;
                this.$emit('success');
              } else {
                this.$message.error(responseData.message || '更新失败');
              }
            })
            .catch(err => {
              let errorMessage = '请求失败';
              if (err.response && err.response.data) {
                errorMessage = err.response.data.message || errorMessage;
              } else if (err.message) {
                errorMessage = err.message;
              }
              this.$message.error(errorMessage);
              console.error('请求错误详情:', err);
            });
      });
    }
  }
};
</script>